import { ACTION_TYPES, AdminViewModel, RegisterStrategy, SaveAdminData } from 'store/admins/types';
import { FirmAdmin } from 'components/FirmAdminList/FirmAdminInterface/FirmAdminInterface';
import apiClient from 'apiClient';
export const setStrategy = (strategy: RegisterStrategy) => ({
  type: ACTION_TYPES.SET_STRATEGY,
  payload: strategy,
});

export const addAdmin = (values: SaveAdminData) => {
  return async () => {
    return new Promise<void>(async (resolve, reject) => {
      await apiClient.post('/api/v1/broker-management/create-admin/', values).catch((e) => reject(e.response));
      resolve();
    });
  };
};

export const storeAdmins = (adminsRawData: FirmAdmin[]) => ({
  type: ACTION_TYPES.STORE_ADMINS,
  payload: adminsRawData,
});

export const updateAdminStatus = (admin: AdminViewModel, newStatus: boolean) => {
  return async (dispatch: any, getState: any) => {
    const firmAdmins = getState().adminsReducer.admins;

    try {
      await apiClient.post(`/api/v1/broker-management/admin/verify/${admin.id}`, { is_verified: newStatus });
      const firmAdminIndex = firmAdmins.findIndex((f: FirmAdmin) => f.id.toString() === admin.id);
      const newFirmAdmins = [...firmAdmins];

      if (firmAdminIndex !== -1) {
        newFirmAdmins[firmAdminIndex].is_verified = newStatus;
        dispatch(storeAdmins(newFirmAdmins));
      }
    } catch (err) {}
  };
};

export const clearForm = () => ({
  type: ACTION_TYPES.CLEAR,
});

export { default as fetchClubs } from './fetchClubs';
